import PropTypes from 'prop-types'
import React from 'react'

import {
    LineClamp,
    Tooltip,
    TooltipBody,
    TooltipSubtitle,
} from 'react-wot-bootstrap'

import { DIALOG_ALLOCATING_RESOURCES_DIVIDE_TO_MEMBERS_TITLE } from './translations'

import { LINE_CLAMP_LINES } from '../constants.js'

export const DialogAllocatingResourcesPlayersTooltip = ({ children }) => (
    <Tooltip id={DialogAllocatingResourcesPlayersTooltip.id}>
        <TooltipBody>
            <TooltipSubtitle>
                {DIALOG_ALLOCATING_RESOURCES_DIVIDE_TO_MEMBERS_TITLE}
            </TooltipSubtitle>
            <LineClamp lines={LINE_CLAMP_LINES}>{children}</LineClamp>
        </TooltipBody>
    </Tooltip>
)
DialogAllocatingResourcesPlayersTooltip.id = 'dialog-allocating-resources-players-body'
DialogAllocatingResourcesPlayersTooltip.propTypes = {
    children: PropTypes.node.isRequired,
}



// WEBPACK FOOTER //
// ./containers/ClanManagement/components/Dialogs/AllocatingResources/tooltips.js